export default {
    "title": "Extranet Administration Panel",
    "description": "Summary of clients, users and logins",
    "clients": "Clients",
    "users": "Users",
    "kpis": {
        "total": "Total",
        "active": "Active",
        "inactive": "Inactive"
    },
    "lastClients": "Last registered clients",
    "lastUsers": "Last registered users",
    "chart": {
        "title": "Logins of last 12 months",
        "series": {
            "logins": "Logins"
        }
    },
    "logins": "Logins",
    "lastLogins": "Last logins"
}